import React, { Component } from "react";
import * as Cookies from "es-cookie";
import { Row, Col, Nav, Card, Image, Tab, Form, Button, Container } from 'react-bootstrap'

import {
    BrowserView,
    MobileView,
    isBrowser,
    isMobile
} from "react-device-detect";

import './_non-academic.scss'
import { CardBody } from "react-bootstrap/Card";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import PreloaderTwo from "../../../preloader/PreloaderTwo";


const GET_FEE_DETAILS = gql`
 query($student_mobile: String) {
    getStudentFeeDetails(student_mobile: $student_mobile) {
        total_fees{
            fee_type
            total_amount
            pending_amount
          }
          paid_fees{
            fee_type
            paid_amount
            paid_date
          }
          due_fees{
            fee_type
            due_date
            due_amount
          }
        }
    }
`;

const GET_OFFLIE_RESULTS = gql`
 query($student_mobile: String,$timeline:Int) {
    getStudentExamResults(student_mobile: $student_mobile,timeline:$timeline) {
        year
        month
        date
        overall_total_rank
        overall_gained_rank
        overall_gained_marks
        overall_total_marks
        overall_avg
        exam_date
        student_marks{
          subject_id
          subject_wise_total_marks
          subject_wise_gained_rank
          subject_wise_gained_marks
          subject_wise_total_rank
          subject_wise_avg
        }
        }
    }
`;


const GET_ATTENDANCE_DETAILS = gql`
 query($student_mobile: String) {
    getStudentAttendance(student_mobile: $student_mobile) {
        year
        month{
          month
          no_of_present
          no_of_absent
          no_of_holidays
          no_of_days
          date{
            date
            is_holiday
            is_present
            dateStatus{
              attendance_type
              attended_status
            }
          }
        }
        }
    }
`;


const FETCH_PARENT_PERMISSION = gql`
query($institute_id: Int!) {
  getParentsPermissionDetails(institute_id: $institute_id) {
    class_id
    exam_id
    branch_id
    section_id
    class_name
    exam_name
    branch_name
    section_name
    permission_id
    student_name
    roll_no
    student_mobile
    request_date
    from_datetime
    to_datetime
    receiver_name
    receiver_mobile
    request_message
    receiver_image_path
    parent_name
    parent_mobile
    permission_status
    comments
    approved_time
    approved_by
    outtime
    outtime_image_path
    outtime_inserted_by
    intime
    intime_image_path
    intime_inserted_by
    permission_request_type_id
    request_title
  }
}
`;



class NAOverAllDetails extends Component {

    render() {

        console.log("props", this.props.stateData.studentData.student_name);

        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
        const currentYear = currentDate.getFullYear();

        const feeDetails = this.props.feeDetails;
        const loading1 = feeDetails.loading;
        const error1 = feeDetails.error;

        const offlineResults = this.props.offlineResults;
        const loading2 = offlineResults.loading;
        const error2 = offlineResults.error;


        const attendanceDetails = this.props.attendanceDetails;
        const loading3 = attendanceDetails.loading;
        const error3 = attendanceDetails.error;


        const parentPermission = this.props.parentPermission;
        const loading4 = parentPermission.loading;
        const error4 = parentPermission.error;


        console.log("offlineResults", attendanceDetails)

        if (loading1 || loading2 || loading3 || loading4) return <PreloaderTwo />;

        if (error1 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error2 !== undefined) {
            alert("Server Error. " + error1.message);
            return null;
        }

        if (error3 !== undefined) {
            alert("Server Error. " + error3.message);
            return null;
        }

        if (error4 !== undefined) {
            alert("Server Error. " + error4.message);
            return null;
        }

        // let overallrequest = 0;
        // let totalrequest = 0;
        // let totalaccept = 0;
        // let totaldecline = 0;


        let totalfee = 0;
        let paidfee = 0;
        let pendingfee = 0;

        let examsConductedLength = 0;
        let examsAttemptedLength = 0;
        let overallPercentage = 0;


        let overAllAttendancePercentage = 0;

        if (attendanceDetails.getStudentAttendance.length > 0) {
            const currentYear = new Date().getFullYear();
            let overallAttendance = attendanceDetails.getStudentAttendance.filter((item) => item.year >= currentYear)[0].month.filter((item1) => (item1.month >= 1 && item1.month <= currentMonth));
            let noOfPresentDays = overallAttendance.reduce((acc, curr) => acc + curr.no_of_present, 0);
            let noOfHolidays = overallAttendance.reduce((acc, curr) => acc + curr.no_of_holidays, 0);
            let noOfDays = overallAttendance.reduce((acc, curr) => acc + curr.no_of_days, 0);
            console.log("overallAttendance", noOfDays);

            if (noOfDays > 0) {

                overAllAttendancePercentage = (((noOfPresentDays + noOfHolidays) / (noOfDays)) * 100).toFixed(2)
            }

        }

        if (feeDetails.getStudentFeeDetails.length > 0) {
            totalfee = feeDetails.getStudentFeeDetails[0].total_fees.reduce((acc, curr) => acc + curr.total_amount, 0);
            paidfee = feeDetails.getStudentFeeDetails[0].paid_fees.reduce((acc, curr) => acc + curr.paid_amount, 0);
            pendingfee = feeDetails.getStudentFeeDetails[0].total_fees.reduce((acc, curr) => acc + curr.pending_amount, 0);

        }

        if (offlineResults.getStudentExamResults.length > 0) {
            examsConductedLength = offlineResults.getStudentExamResults.length;
            examsAttemptedLength = offlineResults.getStudentExamResults.length;
            let overallTotalMarks = offlineResults.getStudentExamResults.reduce((acc, curr) => acc + curr.overall_total_marks, 0);
            let overallGainedMarks = offlineResults.getStudentExamResults.reduce((acc, curr) => acc + curr.overall_gained_marks, 0);
            overallPercentage = ((overallGainedMarks / overallTotalMarks) * 100).toFixed(2);
        }


        // let students = parentPermission.getParentsPermissionDetails

        // const overallrequest = parentPermission.getParentsPermissionDetails.length

        // const totalrequest = students.filter((item) => item.permission_status == null).length

        // const totalaccept = students.filter((item1) => item1.permission_status == "1").length

        // const totaldecline = students.filter((item2) => item2.permission_status == "2").length

        const students = parentPermission.getParentsPermissionDetails.filter(item => item.student_name == this.props.stateData.studentData.student_name);
        console.log("students", students);

        const overallrequest = students.length;
        console.log("overallrequest", overallrequest);

        const totalrequest = students.filter((item) => item.permission_status == null).length
        console.log("totalrequest", totalrequest);

        const totalaccept = students.filter((item1) => item1.permission_status == "1").length
        console.log("totalaccept", totalaccept);

        const totaldecline = students.filter((item2) => item2.permission_status == "2").length
        console.log("totaldecline", totaldecline);


        console.log("fulldata", overallrequest, totalrequest, totalaccept, totaldecline);

        return (
            <div className="overallDetails mt-3">
                <Container fluid >
                    <Row style={{ cursor: "pointer" }}>
                        <Col sm={12} md={4} lg={4}>
                            <Card className="individual_card" style={{ backgroundColor: "#ffa37c" }}>
                                <Card.Body>
                                    <h5 className="text-center mt-2">OFFLINE MARKS</h5>
                                    <h6 className="text-center mt-4 font-color">Exam Taken</h6>
                                    <h5 className="text-center mt-1">{examsAttemptedLength}/{examsConductedLength}</h5>
                                    <h6 className="text-center mt-4 font-color">Average Percentage</h6>
                                    <h5 className="text-center mt-1">{overallPercentage}%</h5>
                                    <p className="text-center mt-4 more_btn" onClick={() => { this.props.selecthandleInputChange("non-academic", 0) }}>Click to get more details</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col sm={12} md={4} lg={4}>
                            <Card className="individual_card" style={{ backgroundColor: "#09db92" }}>
                                <Card.Body >
                                    <h5 className="text-center mt-2" >ATTENDANCE</h5>
                                    <h6 className="text-center  font-color margin_top">Overall Attendance</h6>
                                    <h5 className="text-center mt-1">{overAllAttendancePercentage}%</h5>
                                    <p className="text-center mt-4 more_btn" onClick={() => { this.props.selecthandleInputChange("non-academic", 1) }}>Click to get more details</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col sm={12} md={4} lg={4}>
                            <Card className="individual_card" style={{ backgroundColor: "#ff6c7b" }}>
                                <Card.Body >
                                    <h5 className="text-center mt-1">FEES</h5>
                                    <h6 className="text-center mt-2 font-color">Total Fees</h6>
                                    <h5 className="text-center mt-1">{totalfee}/-</h5>
                                    <h6 className="text-center mt-2 font-color">Paid Fees</h6>
                                    <h5 className="text-center mt-1">{paidfee}/-</h5>
                                    <h6 className="text-center mt-2 font-color">Pending Fees</h6>
                                    <h5 className="text-center mt-1">{pendingfee}/-</h5>
                                    <p className="text-center mt-1 more_btn" onClick={() => { this.props.selecthandleInputChange("non-academic", 2) }}>Click to get more details</p>
                                </Card.Body>
                            </Card>
                        </Col>
                        {/* <Col sm={12} md={3} lg={3}>
                            <Card className="individual_card" style={{ backgroundColor: "#9e71ce" }}>
                                <Card.Body >
                                    <h5 className="text-center">PERMISSION</h5>
                                    <h6 className="text-center font-color">Overall Requests</h6>
                                    <h5 className="text-center ">{overallrequest}</h5>
                                    <h6 className="text-center  font-color">Request Pending</h6>
                                    <h5 className="text-center ">{totalrequest}</h5>
                                    <h6 className="text-center  font-color">Request Accepted</h6>
                                    <h5 className="text-center ">{totalaccept}</h5>
                                    <h6 className="text-center  font-color">Request Decline</h6>
                                    <h5 className="text-center ">{totaldecline}</h5>
                                    <p className="text-center more_btn" onClick={() => { this.props.selecthandleInputChange("non-academic", 3) }}>Click to get more details</p>
                                </Card.Body>
                            </Card>
                        </Col> */}

                    </Row>
                </Container>
            </div>
        );
    }
}

export default withRouter(
    compose(
        graphql(
            GET_FEE_DETAILS,
            {
                options: props => ({
                    variables: {
                        student_mobile: props.stateData.studentData.contact_no.toString()
                    },
                    fetchPolicy: 'network-only'
                }),
                name: "feeDetails"
            }
        ),
        graphql(
            GET_OFFLIE_RESULTS,
            {
                options: props => ({
                    variables: {
                        student_mobile: props.stateData.studentData.contact_no.toString(),
                        timeline: parseInt(4)
                    },
                    fetchPolicy: 'network-only'
                }),
                name: "offlineResults"
            }
        ),
        graphql(
            GET_ATTENDANCE_DETAILS,
            {
                options: props => ({
                    variables: {
                        student_mobile: props.stateData.studentData.contact_no.toString()
                    },
                    fetchPolicy: 'network-only'
                }),
                name: "attendanceDetails"
            }
        ),
        graphql(FETCH_PARENT_PERMISSION, {
            options: (props) => ({
                variables: {
                    institute_id: parseInt(Cookies.get("institutionid")),
                },
                fetchPolicy: "cache-and-network",
            }),
            name: "parentPermission",
        }),
    )(NAOverAllDetails)
);
